import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.81,8.207A4.349,4.349,0,0,0,28,6.427,14.954,14.954,0,0,0,24.37,5c-.365-.1-.75-.188-1.145-.277a1,1,0,0,0-1.2.749A.979.979,0,0,0,22,5.7v5.82a30.673,30.673,0,0,1-3.24.38c-.06,0-.11.01-.17.01-.32.02-.64.04-.97.05-.53.03-1.06.04-1.62.04s-1.09-.01-1.62-.04c-.33-.01-.65-.03-.97-.05-.06,0-.11-.01-.17-.01a30.162,30.162,0,0,1-3.24-.41V5.7a1,1,0,0,0-1-1,.972.972,0,0,0-.228.025C8.38,4.809,8,4.9,7.63,5A14.954,14.954,0,0,0,4,6.427a4.349,4.349,0,0,0-1.81,1.78A2.041,2.041,0,0,0,2,9V23.6a1.006,1.006,0,0,0,.317.732A11.157,11.157,0,0,0,6.14,26.517l9.15-9.15a.99.99,0,0,1,1.4-.02l.02.02L19,19.657l3.29-3.29a.99.99,0,0,1,1.4-.02l.02.02L30,22.657V9A2.041,2.041,0,0,0,29.81,8.207ZM4.01,9c.19-.48,1.54-1.35,3.99-2.03v4.06C5.55,10.347,4.2,9.477,4.01,9ZM8,18.907A1.906,1.906,0,1,1,9.91,17,1.906,1.906,0,0,1,8,18.907Zm16-7.88V6.967c2.45.68,3.8,1.55,3.99,2.03C27.8,9.477,26.45,10.347,24,11.027Z"/><path d="M29.24,24.717C27.79,25.867,24.03,28,16,28a32.451,32.451,0,0,1-7.69-.82L16,19.487l3.29,3.29a1,1,0,1,0,1.42-1.41l-.3-.3L23,18.487Z"/>';
export var Panorama360SVG = function Panorama360SVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
Panorama360SVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(Panorama360SVG);